import { Injectable } from '@angular/core';
import {
    TariffItem,
    TariffProvider,
    TariffProviderView,
    TariffsData,
    TariffService,
    TariffServiceView,
    TariffType,
    TariffTypeView,
    TariffViewModel,
} from '@shared/models/tariffs.model';


/**
 * Tariff tree generation service
 */
@Injectable()
export class TariffsGeneratorService {
    /**
     * Get the rate tree
     * @param data - objects of tariffs, types, services, providers
     */
    public generatePasses<T extends TariffItem>(data: TariffsData<T>): TariffViewModel<T> {
        const resultView: TariffViewModel<T> = {
            providers: [],
        };

        if (!data) {
            return resultView;
        }

        const providers: { [key: number]: TariffProvider } = {};
        const types: { [key: number]: TariffType } = {};
        const services: { [key: number]: TariffService } = {};

        data.providers.map((p) => (providers[p.id] = p));
        data.types.map((t) => (types[t.id] = t));
        data.services.map((s) => (services[s.id] = s));

        data.tariffs.forEach((item) => {
            let providerView: TariffProviderView<T> = resultView.providers.find((i) => i.data && i.data.id === item.provider);

            if (!providerView) {
                providerView = {
                    data: providers[item.provider],
                    types: [],
                };

                resultView.providers.push(providerView);
            }

            let typeView: TariffTypeView<T> = providerView.types.find((i) => i.data && i.data.id === item.type);

            if (!typeView) {
                typeView = {
                    data: types[item.type],
                    services: [],
                };

                providerView.types.push(typeView);
            }

            let serviceView: TariffServiceView<T> = typeView.services.find((i) => i.data && i.data.id === item.service);

            if (!serviceView) {
                serviceView = {
                    data: services[item.service],
                    items: [],
                };

                typeView.services.push(serviceView);
            }

            serviceView.items.push(item);
        });

        /**
         * Manipulation to disable empty provider sections
         */
        resultView.providers.forEach((provider) => {
            provider.isEmpty = provider.types.some((type) => !type.data);
        });

        return resultView;
    }
}
